import React from 'react';

/*
 * If any page crashes, show a message with a reload button instead of a
 * blank white screen. The error is logged to the console for debugging.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Page crashed:', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div translate="no" className="notranslate" style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 20, background: '#07101E', color: '#EEF2F7',
        fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif', textAlign: 'center',
      }}>
        <div style={{ maxWidth: 420 }}>
          <h1 style={{ fontSize: 24, margin: '0 0 10px' }}>Something went wrong</h1>
          <p style={{ color: '#8A9AB2', lineHeight: 1.6, margin: '0 0 20px' }}>
            Please reload the page. If you are using your browser's translate feature,
            turn it off for this site and try again.
          </p>
          <button onClick={() => window.location.reload()} style={{
            height: 44, padding: '0 22px', borderRadius: 12, border: 'none',
            background: '#E2AE4A', color: '#07101E', fontWeight: 700, fontSize: 15, cursor: 'pointer',
          }}>Reload</button>
        </div>
      </div>
    );
  }
}
